// FIXME: Update this file to be type safe and remove this and next line
// @ts-strict-ignore
import { Observable } from "rxjs";

import { ApiService } from "../../abstractions/api.service";
import { UpdateAvatarRequest } from "../../models/request/update-avatar.request";
import { AVATAR_DISK, StateProvider, UserKeyDefinition } from "../../platform/state";
import { UserId } from "../../types/guid";
import { AvatarService as AvatarServiceAbstraction } from "../abstractions/avatar.service";

const AVATAR_COLOR = new UserKeyDefinition<string>(AVATAR_DISK, "avatarColor", {
  deserializer: (value) => value,
  clearOn: [],
});

const AVATAR_IMAGE_URL = new UserKeyDefinition<string | null>(AVATAR_DISK, "avatarImageUrl", {
  deserializer: (value) => value ?? null,
  clearOn: [],
});

export class AvatarService implements AvatarServiceAbstraction {
  avatarColor$: Observable<string>;
  avatarImageUrl$: Observable<string | null>;

  constructor(
    private apiService: ApiService,
    private stateProvider: StateProvider,
  ) {
    this.avatarColor$ = this.stateProvider.getActive(AVATAR_COLOR).state$;
    this.avatarImageUrl$ = this.stateProvider.getActive(AVATAR_IMAGE_URL).state$;
  }

  async setAvatarColor(color: string): Promise<void> {
    const { avatarColor } = await this.apiService.putAvatar(new UpdateAvatarRequest(color));

    await this.stateProvider.setUserState(AVATAR_COLOR, avatarColor);
  }

  async setAvatarImage(file: File): Promise<void> {
    const formData = new FormData();
    formData.append("file", file, file.name);

    const profile = await this.apiService.postAvatarImage(formData);
    await this.applyProfileAvatarState(profile.avatarColor, profile.avatarImageUrl);
  }

  async removeAvatarImage(): Promise<void> {
    const profile = await this.apiService.deleteAvatarImage();
    await this.applyProfileAvatarState(profile.avatarColor, profile.avatarImageUrl);
  }

  async setSyncAvatarColor(userId: UserId, color: string): Promise<void> {
    await this.stateProvider.getUser(userId, AVATAR_COLOR).update(() => color);
  }

  async setSyncAvatarImageUrl(userId: UserId, avatarImageUrl: string | null): Promise<void> {
    await this.stateProvider.getUser(userId, AVATAR_IMAGE_URL).update(() => avatarImageUrl);
  }

  getUserAvatarColor$(userId: UserId): Observable<string | null> {
    return this.stateProvider.getUser(userId, AVATAR_COLOR).state$;
  }

  getUserAvatarImageUrl$(userId: UserId): Observable<string | null> {
    return this.stateProvider.getUser(userId, AVATAR_IMAGE_URL).state$;
  }

  private async applyProfileAvatarState(
    avatarColor: string,
    avatarImageUrl: string | null,
  ): Promise<void> {
    await this.stateProvider.setUserState(AVATAR_COLOR, avatarColor);
    await this.stateProvider.setUserState(AVATAR_IMAGE_URL, avatarImageUrl);
  }
}
